const HamburgerIcon = ({
  stroke = "#000",
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: itsok
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M3 7H21" strokeLinecap="round" strokeWidth="1.5" />
      <path d="M3 12H21" strokeLinecap="round" strokeWidth="1.5" />
      <path d="M3 17H21" strokeLinecap="round" strokeWidth="1.5" />
    </svg>
  );
};

export default HamburgerIcon;
